import React from 'react'
import { connect } from 'react-redux'
import {setAfficherLegende,setAfficherListecouches,setAfficherFenetreExport} from '../redux/actions'

function BandeauGauche({afficherlistecouches,afficherlegende,setAfficherLegende,setAfficherListecouches,setAfficherFenetreExport}) {
    return (
        <div className="bandeaugauche">
            <img src={`${process.env.PUBLIC_URL}/images/couches.png`} onClick={()=>setAfficherListecouches(!afficherlistecouches)} id="couches" style={{ width: "25px", height: "35px" }} title="Afficher/Masquer la liste des couches" alt="Afficher/Masquer la liste des couches" />
            <img src={`${process.env.PUBLIC_URL}/images/legende.png`} onClick={()=>setAfficherLegende(!afficherlegende)} id="afficherlegende" style={{ width: 25, height: 28, marginTop: 4 }} title="Afficher/Masquer la légende" alt="Afficher/Masquer la légende" />
            <img id="exporter" onClick={()=>setAfficherFenetreExport(true)} className="export" src={`${process.env.PUBLIC_URL}/images/export.png`} alt="Export" title="Exporter les données des tableaux" style={{height:32}} />
            <a href={`${process.env.PUBLIC_URL}/Liste_Variables.xlsx`} title="Télécharger la liste des variables">
                <img src={`${process.env.PUBLIC_URL}/images/liste_variables.png`} alt="Liste des variables" style={{ width: 25, height: 28, marginLeft: 8, marginTop: 4 }} />
            </a>
        </div>
    )
}

function mapStateToProps(state) {
    
    return {
        afficherlistecouches:state.afficherlistecouches,
        afficherlegende:state.afficherlegende,
    }
  }

export default connect(mapStateToProps,{setAfficherLegende,setAfficherListecouches,setAfficherFenetreExport}) (BandeauGauche)
